import React from 'react';
import Select from 'react-select';

import ReportConst from '../../util/ReportConst';

class ReportUpdateView extends React.Component {

  render() {
    const options = [
      { label: "List", value: ReportConst.List },
      { label: "Table", value: ReportConst.Table },
      { label: "Pie Chart", value: ReportConst.PieChart },
      { label: "Bar Graph", value: ReportConst.BarGraph },
      { label: "Multi Bar Graph", value: ReportConst.MultiBarGraph },
      { label: "Multi Line Chart", value: ReportConst.MultiLineChart },
      { label: "Funnel", value: ReportConst.Funnel },
      { label: "Gauge", value: ReportConst.Gauge },
      { label: "Download", value: ReportConst.Download }
    ];
    
    return (
      <div className="col-md-4">
        <div className="formhead col-md-12"><h4>Report View</h4></div>
        <div className="condition-select col-md-12">
          <Select 
            value={options.find(option => option.value === this.props.value)} 
            className="mr-sm-2"
            options={options}
            onChange={field => this.props.onChange(field ? field.value : null)} 
            isSearchable={true} isClearable={true} />
        </div>
      </div>
    );
  }
}
export default ReportUpdateView;